<template>

  <v-tooltip
    open-delay=1000
    :left="tooltipLeft"
    :right="tooltipRight"
    :top="tooltipTop"
    :bottom="tooltipBottom"
    >
    <template v-slot:activator="{ on }">
      <span v-on="on" v-if="enableToolTip">
        <v-row no-gutters class="form-group" v-if="!noLabel">
          <span v-if="label !== ''" class="item-label">{{ label }}</span>
          <span v-else class="item-label" style="color:white" />
          <label class="form-group-label">
          <span v-if="required && !readonly" class="mandatory-solo">必須</span>
          </label>
        </v-row>
        <v-textarea
          v-bind="computedProps"
          v-on="computedListeners"
          label=""
          solo
          flat
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0">
        </v-textarea>
      </span>
      <div v-else>
        <v-row no-gutters class="form-group" v-if="!noLabel">
          <span v-if="label !== ''" class="item-label">{{ label }}</span>
          <span v-else class="item-label" style="color:white" />
          <label class="form-group-label">
          <span v-if="required && !readonly" class="mandatory-solo">必須</span>
          </label>
        </v-row>
        <v-textarea
          v-bind="computedProps"
          v-on="computedListeners"
          label=""
          solo
          flat
          :placeholder="phtext"
          :tabindex="readonly ? -1 : 0">
        </v-textarea>
      </div>
    </template>
    <span v-html="tooltipText"></span>
  </v-tooltip>
</template>
<script>
import controls from '@/rahmen/controls'
import validators from '@/rahmen/validators'
import inputMixin from '@/mixins/inputMixins'
import { VTextarea } from 'vuetify/lib'

/**
 * @file DDv2用テキストエリア
 * @namespace components
 */

/**
 * @vue-prop {Boolean} [required=false] - 必須制御有無
 * @vue-prop {Number} [length=Number.MAX_SAFE_INTEGER] - 入力可能桁数
 * @vue-prop {String} [errorMessages=''] - 表示エラーメッセージ
 * @see https://vuetifyjs.com/ja/api/v-textarea/
 * @example
 * <dd-text-area
 *   v-model="textValue"
 *   :required="true"
 * />
 */
export default {
  name: 'DdTextArea',
  extends: VTextarea,
  mixins: [inputMixin],
  props: {
    /**
     * 必須指定
     */
    required: Boolean,
    /**
     * 入力可能桁数
     */
    length: {
      type: Number,
      default: Number.MAX_SAFE_INTEGER
    },
    /**
     * 表示エラーメッセージ
     */
    errorMessages: String,
    /**
     * ツールチップテキスト
     */
    tooltipText: {
      type: String,
      default: ''
    },
    /**
     * ツールチップ表示要否
     */
    enableToolTip: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（左）
     */
    tooltipLeft: {
      type: Boolean,
      default: true
    },
    /**
     * ツールチップ表示位置（上）
     */
    tooltipTop: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（右）
     */
    tooltipRight: {
      type: Boolean,
      default: false
    },
    /**
     * ツールチップ表示位置（下）
     */
    tooltipBottom: {
      type: Boolean,
      default: false
    },
    /**
     * ラベル不要
     */
    noLabel: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    invalidMessage: ''
  }),
  created () {
  },
  mounted () {
    this.invalidMessage = this.errorMessages
    console.log('mounted', this.invalidMessage)
    if (this.invalidMessage === undefined) {
      // this[controls.VALIDATE_METHOD]()
    }
  },
  watch: {
    readonly () {
      if (this.readonly) {
        this.autoReduceTextarea()
      }
    }
  },
  computed: {
    phtext () {
      return this.length && !this.readonly ? '@@length@@文字以内'.replace('@@length@@', this.length) : ' '
    },
    computedProps () {
      return {
        ...this.$props,
        maxlength: this.length,
        // backgroundColor: this.required ? controls.Colors.Required : '',
        class: this.$props.class + (this.readonly ? ' readonly-item' : this.required ? ' required-item' : ''),
        hideDetails: 'auto',
        dense: true,
        error: this.hasError,
        errorMessages: this.invalidMessage
      }
    },
    computedListeners () {
      return {
        ...this.$listeners,
        blur: e => this.onBlur(e),
        focus: e => this.onFocus(e)
      }
    },
    hasError () {
      return this.invalidMessage !== '' && this.invalidMessage !== undefined
    }
  },
  methods: {
    onBlur: function (e) {
      this[controls.VALIDATE_METHOD]()
      if (!this.hasError) {
        this[controls.FORMAT_METHOD]()
      }
      this.$emit('blur', e)
    },
    onFocus: function (e) {
      this.$emit('blur', e)
    },
    [controls.VALIDATE_METHOD]: function () {
      const target = {
        value: this.value,
        length: this.length
      }
      console.log(this)
      this.invalidMessage = undefined
      const validatorList = controls.getInputTypeValidators(this.valueType)

      if (this.required) { validatorList.unshift(validators.requireValidate) }
      if (this.appendValidators) { validatorList.push(...this.appendValidators) }

      for (let i = 0; i < validatorList.length; i++) {
        const f = validatorList[i]
        const ret = f(target)
        console.log(target, f.name, ret)
        if (ret !== undefined) {
          this.invalidMessage = ret
          // this.$set(this, 'invalidMessage', ret)
          return
        }
      }
    },
    [controls.FORMAT_METHOD]: function () {
    },
    autoReduceTextarea () {
      // this.$elのままだと欲しい要素のひとつ後の要素を取ってしまうので、一つもどしてから子要素のtextareaを取得
      const element = this.$el.previousElementSibling.querySelector('textarea')
      const nowHeight = element.getBoundingClientRect().height

      console.log('autoReduceTextarea this.value:', this.value)
      console.log('autoReduceTextarea this.$el:', this.$el)
      console.log('autoReduceTextarea element:', element)
      console.log('autoReduceTextarea nowHeight:', nowHeight)
      element.style.height = 'auto'
      if (this.value && nowHeight && element.scrollHeight) {
        if (nowHeight >= element.scrollHeight) {
          element.style.height = element.scrollHeight + 'px' // 文字の量に合わせた高さ
        } else {
          element.style.height = nowHeight + 'px'
        }
      }
    }
  }
}
</script>
<style scoped>
::v-deep .v-textarea.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded,.v-text-field--outlined)>.v-input__control>.v-input__slot {
  padding-right: 0 !important;
}
::v-deep .v-textarea.v-text-field.v-text-field--enclosed:not(.v-text-field--rounded,.v-text-field--solo-flat)>.v-input__control>.v-input__slot {
  padding-right: 0 !important;
  padding-bottom: 12px !important;
}
::v-deep .v-textarea.v-text-field--solo {
  padding-bottom: 9px !important;
}
</style>
